const libPictView = require('pict-view');

/**
 * The screen a host app routes to for dashboards: a thin frame around HeadlightDashboardHost, which does the loading
 * and painting. Other views can embed a dashboard without this view by calling `host.openInto(element, request)`.
 */
class HeadlightDashboardsView extends libPictView
{
	/**
	 * @param {any} pFable
	 * @param {Record<string, any>} [pOptions]
	 * @param {string} [pServiceHash]
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {{ Hash?: string, IDProject?: number, Filter?: string, FilterExperience?: string, Offset?: number, PageSize?: number, Chooser?: boolean }} */
		this.request = {};
	}

	/**
	 * Set what the next render opens; route handlers call this before rendering.
	 *
	 * @param {{ Hash?: string, IDProject?: number|string, Filter?: string, FilterExperience?: string, Offset?: number|string, PageSize?: number|string, Chooser?: boolean }} pRequest
	 */
	setRequest(pRequest)
	{
		const tmpRequest = pRequest || {};
		this.request =
		{
			Hash: tmpRequest.Hash ? decodeURIComponent(String(tmpRequest.Hash)) : undefined,
			IDProject: parseInt(String(tmpRequest.IDProject || 0), 10) || undefined,
			Filter: tmpRequest.Filter ? String(tmpRequest.Filter) : undefined,
			FilterExperience: tmpRequest.FilterExperience ? decodeURIComponent(String(tmpRequest.FilterExperience)) : undefined,
			Offset: parseInt(String(tmpRequest.Offset || 0), 10) || undefined,
			PageSize: parseInt(String(tmpRequest.PageSize || 0), 10) || undefined,
			Chooser: !!tmpRequest.Chooser,
		};
	}

	/**
	 * @param {any} pRenderable
	 * @return {any}
	 */
	onAfterRender(pRenderable)
	{
		const tmpHost = this.pict.providers.HeadlightDashboardHost;
		if (tmpHost)
		{
			if (this.request.Chooser)
			{
				tmpHost.renderChooser('#HeadlightDashboards-Host', { IDProject: this.request.IDProject });
			}
			else
			{
				tmpHost.openInto('#HeadlightDashboards-Host', this.request);
			}
		}
		return super.onAfterRender(pRenderable);
	}
}

module.exports = HeadlightDashboardsView;

module.exports.default_configuration =
{
	ViewIdentifier: 'HeadlightDashboards',
	DefaultRenderable: 'HeadlightDashboards-Wrap',
	DefaultDestinationAddress: '#HeadlightDashboards-Container',
	AutoRender: false,
	DashboardMode: true,

	CSS: /*css*/`
		.hld-chooser .hld-card { display: block; height: 100%; }
		.hld-frame.is-project-bound { background: var(--theme-color-background-panel, #fff); }
		.hld-project-bar { display: flex; align-items: center; gap: 0.75rem; padding: 0.75rem 15px; border-bottom: 1px solid var(--theme-color-border-light, #e5e7eb); }
		.hld-project-label { font-weight: 600; white-space: nowrap; color: var(--theme-color-text-secondary, inherit); }
		.hld-project-picker { flex: 1; min-width: 0; max-width: 40rem; }
		.hld-project-prompt { padding: 2rem 15px; min-height: 50vh; }
		.hld-project-prompt .title { margin-bottom: 0.5rem; }
		.hld-project-prompt p { color: var(--theme-color-text-muted, inherit); }
		.hld-frame:not(.is-project-bound) { padding: 0 3rem 3rem; }
		@media screen and (max-width: 768px) { .hld-frame:not(.is-project-bound) { padding: 0 1rem 2rem; } }
		.hld-bar { display: flex; flex-wrap: wrap; align-items: baseline; gap: 0.25rem 1.25rem; padding: 0.5rem 15px; font-size: 0.875rem; }
		.hld-frame:not(.is-project-bound) .hld-bar { padding: 0 0 0.75rem; }
		.hld-bar-all { display: inline-flex; align-items: center; gap: 0.35rem; font-weight: 600; }
		.hld-bar-others { display: inline-flex; flex-wrap: wrap; align-items: baseline; gap: 0.25rem 0.5rem; }
		.hld-bar-label { color: var(--theme-color-text-muted, #6b7280); }
		.hld-bar-dot { color: var(--theme-color-text-muted, #6b7280); }
		.hld-unresolved { margin: 1rem 1.5rem 0; }
		.hld-frame:not(.is-project-bound) .hld-unresolved { margin: 0 0 1rem; }
	`,

	Templates:
	[
		{
			Hash: 'HeadlightDashboards-Template',
			Template: '<div id="HeadlightDashboards-Host" class="hld-host"></div>',
		},
	],

	Renderables:
	[
		{
			RenderableHash: 'HeadlightDashboards-Wrap',
			TemplateHash: 'HeadlightDashboards-Template',
			RenderMethod: 'replace',
		},
	],
};
